'use strict';

export default function externalLinks() {
    document.querySelectorAll('a[rel*=external]').forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const href = link.getAttribute('href');

            setTimeout(() => {
                // TODO: add Google Analytics tracking
                window.open(href);
            }, 200);
        });
    });
}
